import CardCommon from '@op/components/CardCommon';
import KeywordItem from '@op/components/Snippets/KeywordItem';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { useRequestKeyword } from '@op/pages/feeds/hooks/useFeedsRequest';
import { LanguageType } from '@op/types/common';
import { keywordLanguageMap } from '@op/utils/languageValue';
import { clickFeedsKeyword } from '@op/utils/url';
import React, { useEffect } from 'react';
import { useHistory, useIntl } from 'umi';

export default function Keyword({
  filter,
  language,
  title = 'Topic Keywords',
  detailKey = 'topic-tracking-keyword',
}: {
  filter: any;
  language: LanguageType;
  title?: string;
  detailKey?: string;
}) {
  const history = useHistory();
  const { feedsKeyword, feedsKeywordLoading, requestKeyword } =
    useRequestKeyword();
  const { formatMessage } = useIntl();

  useEffect(() => {
    requestKeyword(filter);
  }, [filter]);

  return (
    <CardCommon
      CardCommon
      contentCard
      loading={feedsKeywordLoading}
      loadingHeight={70}
      title={formatMessage({ id: title })}
      className="dbo-topic-analysis-keywords-card"
    >
      <div className="dbo-topic-analysis-keywords-list">
        {/* 以下用KeywordItem组件 */}
        {feedsKeyword?.map((keyword: any) => (
          <KeywordItem
            key={keyword.keyword + keyword.count}
            language={language}
            keyword={keyword}
            sentiment_rating={keyword.sentiment_rating}
            count={keyword.count}
            itemClick={() => {
              buriedBtnPoint('Keywords', keyword);
              clickFeedsKeyword({
                detailKey,
                history,
                filter,
                keyword,
              });
            }}
            languageMap={keywordLanguageMap}
          ></KeywordItem>
        ))}
      </div>
    </CardCommon>
  );
}
